window.NREUM = window.NREUM || {}

export function monitorNREUM(appName: string): void {
  const instance = window.nr[appName]

  window.NREUM = {
    setToken: setToken
  }

  function setToken(data: any) {
    if (instance.hasToken) return

    instance.hasToken = true
    ;(instance as any).setToken(data)
  }
}
